export default "<style>\n  \n  callback--button--field\n  {\n    \n  }\n\n  html body [] > button\n  {\n    padding: 0.1em 1em;\n  }\n\n</style>";